import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ButtonProps, ButtonVariant, Dialog } from '@optimus-web/core';

export interface ConfirmationDialogProps {
    cancelChange?: () => void;
    confirmChange?: (e: React.MouseEvent) => void;
    confirmationOpened?: boolean;
    textKey: Mews.TextKey;
    content?: React.ReactNode;
    confirmButtonTextKey?: Mews.TextKey;
    confirmButtonVariant?: ButtonVariant;
    loading?: boolean;
}

/**
 * @deprecated use raw Dialog instead
 */
export const ConfirmationDialog = ({
    confirmationOpened,
    textKey,
    cancelChange,
    confirmButtonTextKey,
    content,
    confirmButtonVariant,
    confirmChange,
    loading,
}: ConfirmationDialogProps) => {
    const dialogActions: ButtonProps[] = [
        {
            children: <LocalizedText textKey={TextKey.GoBack} />,
            onClick: cancelChange,
            variant: 'ghost',
            type: 'submit',
        },
        {
            children: <LocalizedText textKey={confirmButtonTextKey || TextKey.Continue} />,
            onClick: confirmChange,
            variant: confirmButtonVariant ?? 'destructive',
            type: 'submit',
        },
    ];

    return (
        <Dialog
            active={confirmationOpened}
            actions={dialogActions}
            title={<LocalizedText textKey={textKey} />}
            onClose={cancelChange}
            loading={loading}
        >
            {content}
        </Dialog>
    );
};
